module.exports = __webpack_public_path__ + "media/src/images/icon__facebook-70cf18de08cfa8603b5dece7ac00c9b7.png";